import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ColumnTypeIconComponent } from './column-type-icon.component';

@NgModule({
  declarations: [ColumnTypeIconComponent],
  exports: [ColumnTypeIconComponent],
  imports: [CommonModule, MatTooltipModule],
})
export class ColumnTypeIconModule {}
